import type { UnitDraftState } from "@/components/courses/use-unit-draft";
import type { CourseUnit } from "@/lib/api/courseUnits";

export const PLAN_FIELDS = [
  { key: "topic", label: "Session topic", column: "topic", max: 200 },
  { key: "objectives", label: "Session objective", column: "learning_objectives", max: 6011 },
  { key: "preparation", label: "Before the session", column: "preparation_guidance", max: 4000 },
  { key: "recap", label: "After-session recap", column: "recap", max: 2000 },
  { key: "followUp", label: "Next steps", column: "follow_up", max: 2000 },
] as const;
export type PlanFieldKey = typeof PLAN_FIELDS[number]["key"];
export const planWords = (value: string | string[] | null | undefined) => Array.isArray(value) ? value.join("\n") : value ?? "";

export function sessionPlanPublication(unit: CourseUnit | null, state?: UnitDraftState) {
  if (!unit?.publication) return "Not published";
  return PLAN_FIELDS.some(field => (state?.draft[field.key] ?? planWords(unit[field.column])).trim() !== planWords(unit.publication?.[field.column]).trim())
    ? "Changed, not published" : "Published";
}


/** Keep the refusal's cause while naming the plan as the teacher sees it. */
export function planFailureWords(reason: string): string {
  const words = reason.replace(/\bcourse unit(s?)\b/gi, "session plan$1").replace(/\bcurrent revision\b/gi, "current saved version");
  return words.charAt(0).toUpperCase() + words.slice(1);
}

/** Close's own fields: an edit to one of them is answered in Close, not in Prepare. */
export function closeOwnsEdit(field: string | null | undefined): boolean {
  return field === "recap" || field === "followUp";
}
